import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Weekday } from 'planning-portal-library/src/lib/core/domain/models/week-days';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { WeekdayRepository } from 'planning-portal-library/src/lib/core/repositories/weekdays.repository';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { BaseResponse } from '../../shared/base.response';
import { WeekdayWebRepositoryMapper } from './entities/weekday-web-repository-mapper';
import { WeekdayUrls } from './weekday-api-urls';

@Injectable({ providedIn: 'root' })
export class WeekdayWebRepository extends WeekdayRepository {
  private readonly weekDayMapper = new WeekdayWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }
  getWeekdays(): Observable<Weekday[]> {
    return this.http
      .get<BaseResponse<Weekday[]>>(
        `${this.environment.url}${WeekdayUrls.GetWeekdays}`
      )
      .pipe(
        mergeMap((response: BaseResponse<Weekday[]>) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.weekDayMapper.mapFrom))
      .pipe(reduce((items: Weekday[], item: Weekday) => [...items, item], []));
  }
}
